import vue3GoogleLogin from 'vue3-google-login'

export default defineNuxtPlugin(nuxtApp => {
    const config = useRuntimeConfig()

    const googleClientId = config.public.googleClientId

    nuxtApp.vueApp.use(vue3GoogleLogin, {
        clientId: googleClientId,
  })
})
